module.exports = __webpack_public_path__ + "f2f182a528b4c07017ab9601803d4cb8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/image2.png
 ** module id = 280
 ** module chunks = 0
 **/